<template>
    <div class="bizcomp-assets box">
        <el-tabs v-model="activeType" class="tab">
            <el-tab-pane name="assets" label="专户公告">
                <div class="filter-box">
                    <div>日期区间：</div>
                    <date-picker
                        :date="dateSet"
                        sep-text="-"
                        style="width: 310px"
                        v-on:date-get="dateInterval"
                    />
                    <div style="margin-left: 10px">基金名称：</div>
                    <div>
                        <el-select
                            v-model="fundcode"
                            placeholder="选择基金"
                            class="select-class"
                            clearable
                            v-on:change="handleSelect"
                        >
                            <el-option
                                v-for="item in fundList"
                                :key="item.fundcode"
                                :label="item.fundname"
                                :value="item.fundcode"
                            ></el-option>
                        </el-select>
                    </div>
                    <el-button
                        size="small"
                        style="background-color: var(--color-primary); color: #ffffff"
                        v-on:click.prevent="searchDateRec"
                    >
                        查询
                    </el-button>
                    <el-button
                        size="small"
                        style="border-color: var(--color-primary); color: var(--color-primary)"
                        v-on:click.prevent="clearQry"
                    >
                        重置
                    </el-button>
                </div>
                <el-row v-if="noticeList.length <= 0 && hasLoad" class="no-funds">
                    <el-col :span="12" :offset="8">
                        <span class="no-funds-img" />
                        <div class="no-funds-box">
                            <p>暂无数据</p>
                        </div>
                    </el-col>
                </el-row>
                <el-table
                    v-else-if="hasLoad"
                    :data="noticeList"
                    class="tab-list-tit"
                    :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
                >
                    <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                            <div class="btns">
                                <el-button
                                    type="text"
                                    size="small"
                                    v-on:click="openFile(scope.row.fileid, 0)"
                                >
                                    下载
                                </el-button>
                                <div class="line"></div>
                                <el-button
                                    type="text"
                                    size="small"
                                    v-on:click="openFile(scope.row.fileid, 1)"
                                >
                                    预览
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="fundname"
                        label="文件名称"
                        min-width="200"
                        class-name="fund-offset"
                    >
                        <template slot-scope="scope">
                            <div class="fund-name">
                                {{ scope.row.originalname }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="downloadcount" width="200" align="center">
                        <template slot="header">
                            <span>下载次数</span>
                            <el-tooltip
                                :content="downloadCountMsg || '该公告累计被下载的次数'"
                                placement="top"
                            >
                                <i
                                    class="el-icon-info"
                                    style="margin-left: 5px; color: var(--color-text-accent)"
                                ></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <div v-if="scope.row.downloadcount || scope.row.downloadcount == 0">
                                {{ scope.row.downloadcount + "次" }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row v-if="allPage > 0" class="page-box">
                    <el-pagination
                        :page-size="Number(conf.PAGE_SIZE)"
                        :current-page.sync="curPage"
                        layout="->, total, prev, pager, next"
                        :total="Number(allPage)"
                        v-on:current-change="swichPage"
                    />
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import datePicker from "@/components/form/datePicker";
import format from "date-fns/format";
import fundApi from "@/api/fund";

export default {
    name: "FundNotice",
    components: {
        datePicker
    },
    data() {
        return {
            activeType: "assets", // tab类型
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "mini",
                text: "开始时间",
                text2: "结束时间",
                val: ["", ""]
            },
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            fundcode: "", // 搜索基金代码
            noticeList: [], // 公告列表
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            curPage: 1, // 当前页
            hasLoad: false, // 是否已经查询数据
            conf: {}, // 初始化配置文件内容
            fundList: [], // 下拉基金
            fundcodelist: [],
            downloadCountMsg: "" // 下载次数提示信息
        };
    },
    async mounted() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.conf = this.$util.getConfig().const;
        // 获取菜单信息
        const menuItem = this.$util.getMenuItem("105002");
        // 获取下载次数提示信息
        this.downloadCountMsg = menuItem.downloadcountmsg || "";

        await this.getAsset();

        if (this.fundcode || this.fundcodelist.length > 0) {
            this.getNoticeList();
        } else {
            this.hasLoad = true;
        }
    },
    methods: {
        async getAsset() {
            const res = await fundApi.qrySpecialAsset({
                producttype: "@",
                keyword: "",
                pageSize: 10,
                pageNum: 1,
                assetshowtype: "0",
                specialassetflag: "1"
            });
            const returnList = res.data.returnList;
            if (returnList && returnList.length > 0) {
                this.fundList = returnList.map((item) => {
                    return {
                        fundcode: item.fundcode,
                        fundname: item.fundname
                    };
                });

                this.fundcodelist = returnList.map((item) => item.fundcode);

                if (this.$route.query && this.$route.query.fundcode) {
                    this.fundcode = this.$route.query.fundcode;
                }
            }
        },
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 搜索时间区间记录
        searchDateRec() {
            this.curPage = 1;
            this.pageoffset = "1";

            if (this.fundcode || this.fundcodelist.length > 0) {
                this.getNoticeList();
            } else {
                this.hasLoad = true;
            }
        },
        // 获取新一页数据
        swichPage(val) {
            this.pageoffset = val;
            this.getNoticeList();
        },
        // 选中建议项
        handleSelect() {
            this.pageoffset = 1;
            this.getNoticeList();
        },
        async getNoticeList(val, cb) {
            const _x = {
                begintime: this.beginDate,
                endtime: this.endDate,
                fundcode: this.fundcode,
                fundcodelist: this.fundcode ? [] : this.fundcodelist,
                pagesize: cb ? "10" : this.pagecount,
                pagenum: val ? "1" : this.pageoffset,
                type: "9" // 查询专户公告传入类型
            };
            let res = await fundApi.getAnnouncement(_x);
            this.hasLoad = true;
            if (res.data) {
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.noticeList = res.data.list;
                }
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, res.data.list);
                }
            }
        },
        openFile(fileCode, isopenfile) {
            // 下载时传入token参数，作为获取客户信息key
            const token = this.$cache.getSessionToken();
            window.open(
                this.$util.fileDownloadPath(fileCode, isopenfile, isopenfile === 0 ? token : "")
            );
            setTimeout(() => {
                this.getNoticeList();
            }, 1000);
        },
        async clearQry() {
            this.dateSet.val = ["", ""];
            this.beginDate = "";
            this.endDate = "";
            this.fundcode = "";
            if (this.fundcode || this.fundcodelist.length > 0) {
                this.getNoticeList();
            } else {
                this.hasLoad = true;
            }
        }
    }
};
</script>

<style lang="scss">
.box {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: #f1f1f1;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .file-button {
        position: absolute;
        width: 100px;
        height: 40px;
        top: 15px;
        right: 25px;
        background: #f1f1f1;
        color: #666666;
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
    }

    .filter-box {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        gap: 16px;
        padding: 20px;
        .input-search {
            width: 320px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                color: #999999;
            }
            .el-input__inner {
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
        .el-input--mini .el-input__inner {
            height: 32px;
        }
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
}
</style>
